module.exports = __webpack_public_path__ + "static/media/skull.a6897439.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/skull.svg
// module id = 1010
// module chunks = 0